// extracted by mini-css-extract-plugin
module.exports = {"footer":"style_footer__3oX6t","copyright":"style_copyright__iBDSQ"};